import React from "react";
import "./App.css";
import { LanguageProvider } from "./contexts/LanguageContext";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Services from "./components/Services";
import VideoSection from "./components/VideoSection";
import ImageCarousel from "./components/ImageCarousel";
import Technology from "./components/Technology";
import Industries from "./components/Industries";
import AboutUs from "./components/AboutUs";
import WhyChooseUs from "./components/WhyChooseUs";
import ContactForm from "./components/ContactForm";
import Footer from "./components/Footer";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <Header />
        <Hero />
        <Services />
        <VideoSection />
        <ImageCarousel />
        <Technology />
        <Industries />
        <AboutUs />
        <WhyChooseUs />
        <ContactForm />
        <Footer />
        <Toaster />
      </div>
    </LanguageProvider>
  );
}

export default App;
